import PosUiConfirmDialog from '@/components/pos-v2/ui/PosUiConfirmDialog.vue';
import { useModal } from './use-modal';

export interface IConfirmDialogOptions {
  title: string;
  message: string;
  acceptText: string;
  /** Defaults to «Cancelar». */
  cancelText?: string;
  /** `danger` draws the accept button red soft (destructive answers). */
  tone?: 'primary' | 'danger';
}

/** Distinct modal names: two dialogs open at once must not hide each other. */
let sequence = 0;

/** V2 confirmations (PosUiConfirmDialog). Call at the top of `setup`. */
export function useConfirmDialog() {
  const modals = useModal();

  /** Resolves true when accepted; false when cancelled or closed. */
  async function confirm(options: IConfirmDialogOptions): Promise<boolean> {
    sequence += 1;
    const dialogName = `confirm-v2-${sequence}`;
    const accepted = await modals.showDynamicDialog<boolean | null>(
      PosUiConfirmDialog,
      { ...options, dialogName },
      dialogName,
      {
        adaptive: true,
        width: 440,
        maxWidth: window.innerWidth * 0.95,
        height: 'auto',
        clickToClose: false,
      }
    );
    return accepted === true;
  }

  return { confirm };
}
